/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ServerLengthStatus = {
    Ok: 'OK',
    NoFish: 'NO_FISH',
    Error: 'ERROR',
} as const;
export type ServerLengthStatus = typeof ServerLengthStatus[keyof typeof ServerLengthStatus];


export function instanceOfServerLengthStatus(value: any): boolean {
    for (const key in ServerLengthStatus) {
        if (Object.prototype.hasOwnProperty.call(ServerLengthStatus, key)) {
            if (ServerLengthStatus[key as keyof typeof ServerLengthStatus] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ServerLengthStatusFromJSON(json: any): ServerLengthStatus {
    return ServerLengthStatusFromJSONTyped(json, false);
}

export function ServerLengthStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ServerLengthStatus {
    return json as ServerLengthStatus;
}

export function ServerLengthStatusToJSON(value?: ServerLengthStatus | null): any {
    return value as any;
}

export function ServerLengthStatusToJSONTyped(value: any, ignoreDiscriminator: boolean): ServerLengthStatus {
    return value as ServerLengthStatus;
}

